<template>
  <BfTable
    ref="table"
    :columns="tableColumns"
    :data="data"
    border
    cell-class-name="tasaciones-small-cell"
    :max-height="maxHeight"
    @row-click="rowClick"
  >
    <template
      v-for="({ dataKey }) in tableColumns"
      :slot="dataKey"
      slot-scope="payload"
    >
      <slot v-bind="payload">
        <template v-if="dataKey === 'table_checkbox'">
          <BfCheckbox
            v-if="allowSelect"
            data-key="checkbox"
            :value="selectedRows.indexOf(payload.row.id) >= 0"
            :bottom-gutter="false"
            :display-label="false"
            class="table-checkbox"
            @update="rowCheckboxChange($event, payload.row)"
          />
        </template>

        <span
          v-else-if="dataKey === 'codigo'"
          class="tasaciones-table-marker"
          :key="dataKey"
        >
          {{payload.row.codigo}}
        </span>

        <template v-else-if="dataKey === 'urgente'">
          {{payload.row.urgente ? 'Si' : 'No'}}
        </template>

        <template v-else-if="dataKey === 'inmueble_visita_exterior'">
          {{payload.row['inmueble_visita_exterior'] ? 'Si' : 'No'}}
        </template>

        <template v-else-if="dataKey === 'tiene_documentacion'">
          {{payload.row['tiene_documentacion'] ? 'Si' : 'No'}}
        </template>

        <template v-else>
          {{payload.row[dataKey]}}
        </template>
      </slot>
    </template>
  </BfTable>
</template>

<script>
export default {
  name: 'ChargesTable',

  props: {
    allowSelect: {
      type: Boolean,
    },

    columns: {
      type: Array,
    },

    data: {
      type: Array,
    },

    maxHeight: {
      type: [String, Number],
    },

    selectedRows: {
      type: Array,
      default: () => [],
    },

    showLocationColumns: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    rowCheckboxChange({ value }, row) {
      this.$emit('row-checkbox-change', {
        row,
        value,
      });
    },

    rowClick({ column, row }) {
      if (column.property === 'codigo') {
        const { id } = row;
        this.$router.push({ name: 'charge', params: { id: `${id}` } });
      }
    },
  },

  computed: {
    hasCustomColumns() {
      return this.columns && Array.isArray(this.columns);
    },

    tableColumns() {
      const checkboxCol = {
        label: '',
        dataKey: 'table_checkbox',
        width: '50',
      };

      if (this.hasCustomColumns) {
        return [...(this.allowSelect ? [checkboxCol] : []), ...this.columns];
      }

      const locationColumns = [
        {
          label: 'Dirección',
          dataKey: 'inmueble_direccion',
          width: '100',
        },
        {
          label: 'Población',
          dataKey: 'inmueble_poblacion',
          width: '100',
        },
        {
          label: 'CP',
          dataKey: 'inmueble_codigopostal',
          width: '80',
        },
      ];

      return [
        ...(this.allowSelect ? [checkboxCol] : []),
        {
          label: 'Cod',
          dataKey: 'codigo',
          width: '100',
          sortable: true,
        },
        {
          label: 'Nº Encargo',
          dataKey: 'numero_encargo',
          sortable: true,
        },
        {
          label: 'Expediente',
          dataKey: 'expediente',
          width: '110',
        },
        {
          label: 'Valtin',
          dataKey: 'num_valoracion',
          width: '100',
        },
        {
          label: 'Cliente',
          dataKey: 'nombre_empresa_cliente',
          width: '100',
        },
        {
          label: 'Solicitante',
          dataKey: 'solicitante_nombre',
          width: '100',
        },
        ...(this.showLocationColumns ? locationColumns : []),
        {
          label: 'T. Vis.',
          dataKey: 'tasador_encargado_codigo',
          width: '100',
        },
        {
          label: 'Trabajo',
          dataKey: 'tipo_trabajo_clave',
          width: '70',
        },
        {
          label: 'Inmueble',
          dataKey: 'tipo_inmueble_clave',
          width: '84',
        },
        {
          label: 'Vis. Ext.',
          dataKey: 'visita_exterior_texto',
          width: '104',
        },
      ].map(col => ({ ...col, showOverflowTooltip: true }));
    },
  },
};
</script>

<style lang="scss" scoped>
.table-checkbox {
  text-align: center;
  padding-right: 2px;

  /deep/ .el-checkbox {
    margin-bottom: 0;

    &__label {
      display: none;
    }
  }
}
</style>
